const bedc = [
	'bedc:organization:read:{organizationId}',
	'bedc:organization:read:{organizationId}/activity',
	'bedc:organization:read:{organizationId}/config',
	'bedc:organization:read:{organizationId}/job',

	'bedc:organization:lookup',
	'bedc:organization:list',

	'bedc:organization:search',

	'bedc:organization:create',

	'bedc:organization:update:{organizationId}',
	'bedc:organization:update:{organizationId}/config',
	'bedc:organization:update:{organizationId}/job',
] as const;

const integration = [
	'integration:organization:create',
	'integration:organization:read:{organizationId}',
	'integration:organization:list',
	'integration:organization:update',
] as const;

export default [...bedc, ...integration] as const;
